import React, { useContext } from 'react';
import { Title4, TextLarge, ButtonsBlock, PrimaryButton, TertiaryButton } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-internal/js-react-i18n';
import { trackGAEvent } from '../../../utils/gaTracking';
import Classes from './SellNudge.module.scss';
import EnvironmentContext from '../../../contexts/EnvironmentContext';

const SellNudge = ({ withPriceCheckLink }: { withPriceCheckLink: boolean }) => {
  const { t } = useI18nContext();
  const {
    tenantContext: { tenant },
  } = useContext(EnvironmentContext);
  const withSmudge = tenant === 'mp';

  return (
    <section className={`${Classes.root} ${withSmudge ? Classes.withSmudge : ''}`}>
      <div className={Classes.content}>
        <Title4 as="h6" utilities={['marginBottomXs']} className="Section-title">
          <span>{t('sell.page.nudge.title')}</span>
          <span className="Title-highlight">{t('sell.page.nudge.titleHighlight')}</span>
        </Title4>
        <TextLarge utilities={['marginBottomXxs']}>{t('sell.page.nudge.body')}</TextLarge>
        <ButtonsBlock className={Classes.ctaContainer}>
          {withPriceCheckLink && (
            <TertiaryButton href="#check-de-dagwaarde" as="a">
              {t('sell.page.nudge.cta1')}
            </TertiaryButton>
          )}
          <PrimaryButton
            as="a"
            href="/plaats/91"
            onClick={() => {
              trackGAEvent('placeAdButtonClicked', 'article');
            }}
          >
            {t('sell.page.nudge.cta2')}
          </PrimaryButton>
        </ButtonsBlock>
      </div>
    </section>
  );
};

export default SellNudge;
